import userService from "../../services/user.service";
import {
  ActionTypes,
  VideoLibraryDataTableActionTypes,
} from "../Constants/ActionTypes";
import {
  setBreakdownColumnSetData,
  setColumnSetStatusData,
} from "./ColumnSetAction";
import { openFailDialog } from "./PopupActions";
import { openSuccessPopup } from "./PopupActions";

export const setIsTableDisabled = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_IS_TABLE_DISABLED,
    payload: payload,
  });
};

export const setVideoLibraryTableData = (dispatch, payload) => {
  const { schoolId, seasonInfo, activeBreakdowns, selectedColumnSet } = payload;
  dispatch({
    type: VideoLibraryDataTableActionTypes.TABLE_LOADING,
    payload: true,
  });
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_ERRORS,
    payload: {
      errorField: "tableFetchError",
      errorMessage: null,
    },
  });
  userService
    .getAllMediaByPlaylist(schoolId, seasonInfo.year, seasonInfo.playListId)
    .then((res) => {
      // get default column set name
      userService.getDefaultODKBreakdownData(schoolId).then((result) => {
        const { columnName } = result.data.data;
        const { mediaBreakdownDetails } = res?.data?.data;
        const temp = [...mediaBreakdownDetails];
        temp?.map((el) => {
          el.row = activeBreakdowns?.map((el1) => {
            return {
              breakdownName: el1?.breakdownName,
              id: el1?.id,
              possibleValues: el1?.possibleValues?.split(","),
              value: el.mediaBreakdownList
                .filter(
                  (ele2) =>
                    ele2?.breakdownName == el1?.breakdownName &&
                    ele2.columnSetName == columnName
                )
                .map((el3) => el3?.value)
                .toString(),
              type: el1.breakdownType.breakdownTypeName,
              mediaBreakdownId: el?.mediaBreakdownList
                .filter(
                  (ele2) => ele2?.breakdownName == el1?.breakdownName
                  //ele2?.columnSetName == el1?.breakDownColumnName
                )
                .map((el3) => el3?.mediaBreakdownId)
                .at(-1),
              loading: false,
            };
          });
        });
        dispatch({
          type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_TABLE_DATA,
          payload: temp ? temp : [],
        });
        dispatch({
          type: VideoLibraryDataTableActionTypes.TABLE_LOADING,
          payload: false,
        });
      });
    })
    .catch((err) => {
      dispatch({
        type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_TABLE_DATA,
        payload: [],
      });
      dispatch({
        type: VideoLibraryDataTableActionTypes.SET_ERRORS,
        payload: {
          errorField: "tableFetchError",
          errorMessage:
            "Something Went Wrong While Fetching Data Table Information.",
        },
      });
      dispatch({
        type: VideoLibraryDataTableActionTypes.TABLE_LOADING,
        payload: false,
      });
    });
};

export const renameColumnSet = (dispatch, payload) => {
  const { id, schoolId, columnName, apiCall } = payload;
  userService
    .renameColumnSet(id, schoolId, columnName)
    .then(async () => {
      await apiCall();
      dispatch({
        type: ActionTypes.CLOSE_RENAME_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Column Set Renamed Successfully.",
            open: true,
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.CLOSE_RENAME_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const deleteColumnSet = (dispatch, payload) => {
  const { id, apiCall } = payload;
  userService
    .deleteColumnSet(id)
    .then(async (res) => {
      await apiCall();
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Column Set Deleted Successfully.",
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const setSelectedPlaylist = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_SELECTED_PLAYLIST,
    payload: payload,
  });
};

export const setVideoLibraryTableStateByName = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME,
    payload: payload,
  });
};

export const setActiveBreakdownForColumnSetSelected = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_ACTIVE_BREAKDOWN_LIST,
    payload: payload,
  });
};

export const setDefaultColumnSet = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_DEFAULT_COLUMN_SET,
    payload: payload,
  });
};

export const setSelectedColumnSet = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_SELECTED_COLUMN_SET,
    payload: payload,
  });
};

export const filterVideoLibraryDataTable = (dispatch, payload) => {
  const valuesToCompare = payload?.filterConditions;
  const filteredBreakdown = payload?.tableData?.filter((item) =>
    item?.row?.some((rowItem) => {
      const rowValue = rowItem?.value;
      const rowType = rowItem?.type;

      if (rowType === "Number") {
        return valuesToCompare?.some((compareItem) => {
          const compareValues = Array.isArray(compareItem?.value)
            ? compareItem.value.map(Number)
            : [Number(compareItem?.value)];

          switch (compareItem?.operator) {
            case "===":
              return (
                compareValues.includes(Number(rowValue)) &&
                rowItem?.breakdownName === compareItem?.breakDownName
              );
            case ">":
              return (
                compareValues.some(
                  (compareValue) => Number(rowValue) > compareValue
                ) && rowItem?.breakdownName === compareItem?.breakDownName
              );
            case "<":
              return (
                compareValues.some(
                  (compareValue) => Number(rowValue) < compareValue
                ) && rowItem?.breakdownName === compareItem?.breakDownName
              );
            case "!==":
              return (
                !compareValues.includes(Number(rowValue)) &&
                rowItem?.breakdownName === compareItem?.breakDownName
              );
            case "<>":
              const [minValue, maxValue] = compareValues.map(Number);
              const numericRowValue = Number(rowValue);
              return (
                numericRowValue >= minValue &&
                numericRowValue <= maxValue &&
                rowItem?.breakdownName === compareItem?.breakDownName
              );
            default:
              return false;
          }
        });
      }

      return valuesToCompare.some((compareItem) =>
        Array.isArray(compareItem?.value)
          ? compareItem?.value.includes(rowValue) &&
            compareItem?.breakDownName === rowItem?.breakdownName
          : compareItem?.value === rowValue &&
            compareItem?.breakDownName === rowItem?.breakdownName
      );
    })
  );

  dispatch({
    type: VideoLibraryDataTableActionTypes.APPLIED_FILTER_LIST,
    payload: [
      ...new Map(
        valuesToCompare?.map((item) => [item?.breakDownName, item])
      ).values(),
    ],
  });

  dispatch({
    type: VideoLibraryDataTableActionTypes.FILTER_TABLE,
    payload: filteredBreakdown,
  });
};

export const setSelectedVideoPath = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SELECTED_VIDEO_PATH,
    payload: payload,
  });
};

export const setErrors = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_ERRORS,
    payload: payload,
  });
};

export const resetVideoLibraryDataTable = (dispatch) => {
  dispatch({ type: VideoLibraryDataTableActionTypes.RESET_TABLE });
};

export const addBreakDownValue = (dispatch, payload) => {
  const {
    row,
    breakDown,
    value,
    schoolId,
    currentUserId,
    scheduleId,
    preRowValue,
  } = payload;

  return new Promise((resolve, reject) => {
    dispatch({
      type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME,
      payload: {
        breakDownId: breakDown?.id,
        rowId: row?.id,
        fieldName: "focus",
        value: false,
        table: "filteredTableData",
      },
    });

    dispatch({
      type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME,
      payload: {
        breakDownId: breakDown?.id,
        rowId: row?.id,
        fieldName: "isEditable",
        value: false,
        table: "filteredTableData",
      },
    });
    resolve();
  });
};

export const updateBreakDownValue = (dispatch, payload) => {
  const {
    row,
    breakDown,
    value,
    schoolId,
    currentUserId,
    scheduleId,
    initialValue,
  } = payload;
  return new Promise((resolve, reject) => {
    dispatch({
      type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME,
      payload: {
        breakDownId: breakDown?.id,
        rowId: row?.id,
        fieldName: "focus",
        value: false,
        table: "filteredTableData",
      },
    });

    dispatch({
      type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME,
      payload: {
        breakDownId: breakDown?.id,
        rowId: row?.id,
        fieldName: "isEditable",
        value: false,
        table: "filteredTableData",
      },
    });
    resolve();
  });
};

export const addTableActivity = (id, schoolId, currentUserId, scheduleId) => {
  const isOnPage = true;
  const pageName = "Cell";
  const type = "VIDEO_EDIT";
  try {
    userService.addActivityVideoEdits(
      scheduleId,
      isOnPage,
      pageName,
      currentUserId,
      id,
      type,
      schoolId
    );
  } catch (err) {}
};

export const updateVideoNameInsideTable = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.UPDATE_VIDEO_NAME,
    payload,
  });
};

export const deleteBreakdown = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.DELETE_BREAKDOWN,
    payload,
  });
};

export const setIsTableEditable = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.IS_TABLE_EDITABLE,
    payload,
  });
};

export const saveTable = (dispatch, payload) => {
  const {
    selectedColumnSet,
    tableData,
    schoolId,
    table,
    filteredTableData,
    scheduleId,
    currentUserId,
  } = payload;
  const isTableValid = tableData.every((data) =>
    data?.row?.every((rowData) => !rowData?.error)
  );
  if (!isTableValid) {
    dispatch({
      type: ActionTypes.OPEN_FAIL_DIALOG,
      payload: {
        open: true,
        message: "Table Data Is Invalid.",
      },
    });
  } else {
    const saveValue = [];
    const updateValue = [];
    let unionArray = [];
    if (filteredTableData) {
      unionArray = filteredTableData?.concat(
        tableData.filter(
          (item2) => !filteredTableData.some((item1) => item1.id === item2.id)
        )
      );
    } else {
      unionArray = tableData;
    }
    dispatch({
      type: VideoLibraryDataTableActionTypes.LOADING_ON_TABLE_DATA_ADD_EDIT,
      payload: true,
    });
    const extractSaveAndUpdateValues = (element) => {
      const sv = element?.row
        ?.map((el) => {
          if (!el?.mediaBreakdownId && el?.value) {
            return {
              eventId: element?.event?.id,
              eventMediaId: element?.eventMedia?.id,
              breakdownId: el.id,
              value: el?.value,
              schoolId,
            };
          }
          return null;
        })
        .filter((el) => el !== null && el !== undefined);

      const upd = element?.row
        ?.map((el) => {
          if (el?.mediaBreakdownId) {
            return {
              mediaBreakdownId: el?.mediaBreakdownId,
              value: el?.value,
            };
          }
          return null;
        })
        .filter((el) => el !== null && el !== undefined);

      return { sv, upd };
    };
    unionArray.forEach((element) => {
      let sv1 = [];
      let upd1 = [];

      const { sv, upd } = extractSaveAndUpdateValues(element);

      if (sv && sv.length > 0) {
        sv1 = sv.map((element) => ({
          ...element,
          columnSetName: selectedColumnSet?.columnName,
        }));
      }

      if (upd && upd.length > 0) {
        upd1 = upd.map((element) => ({
          ...element,
          columnSetName: selectedColumnSet?.columnName,
        }));
      }

      saveValue.push(...sv1);
      updateValue.push(...upd1);
    });
    const saveBreakDownTable =
      saveValue && saveValue?.length > 0
        ? userService.addBreakDownValuesToTable(saveValue)
        : Promise.resolve(null);
    const updateBreakDownTable =
      updateValue && updateValue?.length > 0
        ? userService.updateBreakDownValuesToTable(updateValue)
        : Promise.resolve(null);

    Promise.all([saveBreakDownTable, updateBreakDownTable])
      .then(([saveResponse, updateResponse]) => {
        if (saveResponse) {
          const { data } = saveResponse?.data;
          data?.forEach((el, index) => {
            saveValue[index].mediaBreakdownId = el?.id;
          });
          saveValue?.forEach((el) => {
            dispatch({
              type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME,
              payload: {
                breakDownId: el?.eventMediaId,
                rowId: el?.breakdownId,
                fieldName: "mediaBreakdownId",
                value: el?.mediaBreakdownId,
                table,
              },
            });
          });
        }
        addTableActivity(
          tableData[0]?.eventMedia?.id,
          schoolId,
          currentUserId,
          tableData[0]?.event?.schedule?.id
        );
        dispatch({
          type: VideoLibraryDataTableActionTypes.LOADING_ON_TABLE_DATA_ADD_EDIT,
          payload: false,
        });
        dispatch({
          type: VideoLibraryDataTableActionTypes.IS_TABLE_EDITABLE,
          payload: false,
        });
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: "Table Updated Successfully.",
              open: true,
            },
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: VideoLibraryDataTableActionTypes.LOADING_ON_TABLE_DATA_ADD_EDIT,
          payload: false,
        });
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: "Something Went Wrong While Updating Table.",
              open: true,
            },
          },
        });
      });
  }
};

export const setTableData = (dispatch, payload) => {
  let activeBreakdown = payload?.activeBreakDownList;
  try {
    const {
      schoolId,
      activeBreakDownList,
      selectedColumnSet,
      seasonType,
      eventType,
      eventName,
      practiceName,
      opponentName,
    } = payload?.selectedSeasonInfo;
    dispatch({
      type: VideoLibraryDataTableActionTypes.TABLE_LOADING,
      payload: true,
    });
    dispatch({
      type: VideoLibraryDataTableActionTypes.SET_SEASON_INFO_OF_TABLE,
      payload: payload.selectedSeasonInfo,
    });
    const removeScheduleId = (obj) => {
      if (!obj) return null;
      const { scheduleId, ...rest } = obj;
      return rest;
    };
    if (
      JSON.stringify(removeScheduleId(payload.selectedSeasonInfo)) !==
      JSON.stringify(removeScheduleId(payload.tableSeasonInfo))
    ) {
      setVideoLibraryTableData(dispatch, {
        schoolId,
        seasonInfo: payload.selectedSeasonInfo,
        activeBreakdowns: activeBreakDownList
          ? activeBreakDownList
          : activeBreakdown,
        selectedColumnSet,
      });
    }
  } catch (error) {
    openFailDialog(dispatch, {
      open: true,
      message: "Something Went Wrong While Fetching Active Breakdowns.",
    });
  }
};

export const setSeasonInfoOfTable = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.TABLE_LOADING,
    payload: true,
  });
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_SEASON_INFO_OF_TABLE,
    payload: payload.selectedSeasonInfo,
  });
  const removeScheduleId = (obj) => {
    if (!obj) return null;
    const { scheduleId, ...rest } = obj;
    return rest;
  };
  if (
    JSON.stringify(removeScheduleId(payload.selectedSeasonInfo)) !==
    JSON.stringify(removeScheduleId(payload.tableSeasonInfo))
  ) {
    const { schoolId } = payload.selectedSeasonInfo;
    userService
      .getAllBreakDownColumnData(schoolId)
      .then((res) => {
        const { breakdownMap, columnNameList } = res.data.data;
        setBreakdownColumnSetData(dispatch, breakdownMap);
        setColumnSetStatusData(dispatch, columnNameList);
        const currentColumnSet = columnNameList.filter(
          (el) => el.isDefaultColumn
        );
        setSelectedColumnSet(dispatch, {
          id: currentColumnSet[0]?.id,
          columnName: currentColumnSet[0]?.columnName,
        });
        const newSortedData = breakdownMap[currentColumnSet[0]?.columnName][
          "activeBreakdowns"
        ].sort(
          (a, b) => parseInt(a.positionNumber) - parseInt(b.positionNumber)
        );
        const filteredActiveData = newSortedData.map((el) => ({
          ...el,
          id: el.id.toString(),
        }));
        setActiveBreakdownForColumnSetSelected(dispatch, filteredActiveData);
        setVideoLibraryTableData(dispatch, {
          schoolId,
          seasonInfo: payload.selectedSeasonInfo,
          activeBreakdowns:
            breakdownMap[currentColumnSet[0]?.columnName]["activeBreakdowns"],
          selectedColumnSet: {
            id: currentColumnSet[0]?.id,
            columnName: currentColumnSet[0]?.columnName,
          },
        });
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong While Fetching Active Breakdowns.",
        });
      });
  }
};
